<template>
  <div class="planilha-alertas">
    <ListaRecolhivel
      titulo="Reservas diferentes do mesmo CPF"
      :total="mesmoCpf.length"
    >
      <div v-if="mesmoCpf.length" class="detail-table-wrap">
        <table class="detail-table alerta-table alerta-cpf">
          <colgroup>
            <col class="col-chevron" />
            <col />
            <col class="col-cpf" />
            <col class="col-qtd" />
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>Passageiro</th>
              <th>CPF</th>
              <th class="num">Vouchers</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(g, k) in mesmoCpf">
              <tr
                :key="chaveCpf(g, k)"
                class="alerta-row"
                :class="{ 'is-open': cpfAberto === chaveCpf(g, k) }"
                @click="toggleCpf(chaveCpf(g, k))"
              >
                <td class="alerta-chevron">
                  <v-icon
                    size="18"
                    class="alerta-chev"
                    :class="{ 'is-open': cpfAberto === chaveCpf(g, k) }"
                    >mdi-chevron-right</v-icon
                  >
                </td>
                <td>
                  <div class="alerta-nome">{{ g.passageiro || "—" }}</div>
                  <span v-if="g.nomes_diferentes" class="alerta-flag"
                    >nomes diferentes para o mesmo CPF</span
                  >
                  <span v-if="g.generico" class="alerta-flag"
                    >CPF em muitos vouchers (possível dado genérico)</span
                  >
                </td>
                <td class="mono">{{ g.cpf }}</td>
                <td class="num">{{ g.vouchers.length }}</td>
              </tr>
              <tr
                v-if="cpfAberto === chaveCpf(g, k)"
                :key="chaveCpf(g, k) + '-det'"
                class="alerta-det"
              >
                <td colspan="4">
                  <ul class="alerta-vouchers">
                    <li v-for="v in g.vouchers" :key="v.localizador">
                      <strong>{{ v.localizador }}</strong>
                      <span v-if="v.codigo" class="muted"> · {{ v.codigo }}</span>
                      <span v-if="v.data_ini" class="muted">
                        · {{ v.data_ini
                        }}<template v-if="v.data_fim && v.data_fim !== v.data_ini">
                          a {{ v.data_fim }}</template
                        >
                      </span>
                      <span v-if="v.produto" class="muted">
                        · {{ v.produto }}</span
                      >
                      <span class="alerta-situacao">{{ v.situacao }}</span>
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div
        v-else-if="verificado.mesmoCpf"
        class="detail-empty detail-empty--ok"
      >
        <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
        Nenhuma reserva.
      </div>
      <div v-else class="detail-empty detail-empty--ok">
        <v-icon size="18" color="#8a929b">mdi-help-circle-outline</v-icon>
        Ainda não verificado.
      </div>
    </ListaRecolhivel>

    <ListaRecolhivel
      v-if="foraDaPlanilha.length || verificado.foraDaPlanilha"
      titulo="Reservas ativas no Phoenix e não estão na planilha"
      :total="foraDaPlanilha.length"
    >
      <div v-if="!foraDaPlanilha.length" class="detail-empty detail-empty--ok">
        <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
        Nenhuma reserva.
      </div>
      <div v-else class="detail-table-wrap">
        <table class="detail-table alerta-table">
          <thead>
            <tr>
              <th>Reserva / Voucher</th>
              <th>Cliente</th>
              <th>Status no Phoenix</th>
              <th>Serviços</th>
              <th>Cancelamento por e-mail</th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(r, k) in foraDaPlanilha"
              :key="`${r.base}-${r.localizador}-${k}`"
            >
              <td>
                <strong>{{ r.localizador }}</strong>
                <span v-if="r.codigo" class="muted"> · {{ r.codigo }}</span>
              </td>
              <td class="ellipsis">{{ r.cliente || "—" }}</td>
              <td>{{ r.status_label || r.status }}</td>
              <td>
                <span v-if="r.data_ini">{{ r.data_ini }}</span>
                <span v-if="r.data_fim && r.data_fim !== r.data_ini">
                  a {{ r.data_fim }}</span
                >
                <span v-if="r.tipos" class="muted"> · {{ r.tipos }}</span>
              </td>
              <td class="alerta-canc">
                <template v-if="r.cancelamento_email">
                  <span class="alerta-canc__ok">
                    Cancelamento confirmado por e-mail da Azul ·
                    {{ dataHoraBr(r.cancelamento_email.em) }}
                  </span>
                  <span
                    v-if="r.cancelamento_email.posterior"
                    class="alerta-flag"
                    :title="r.cancelamento_email.posterior.assunto"
                  >
                    E-mail posterior ({{
                      dataHoraBr(r.cancelamento_email.posterior.em)
                    }}): a reserva pode ter sido refeita
                  </span>
                </template>
                <span v-else-if="r.cancelamento_verificado" class="muted">
                  Sem e-mail de cancelamento
                </span>
                <span v-else class="muted">Não verificado</span>
              </td>
              <td>{{ r.motivo }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ListaRecolhivel>

    <ListaRecolhivel
      titulo="Apelidos cadastrados pelo agente"
      :total="apelidosCriados.length"
    >
      <div v-if="apelidosCriados.length" class="detail-table-wrap">
        <table class="detail-table alerta-table">
          <thead>
            <tr>
              <th>Apelido (como a Azul mandou)</th>
              <th>Hotel no Phoenix</th>
              <th>Confiança</th>
              <th>Reserva</th>
              <th>Quando</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(a, k) in apelidosCriados"
              :key="`${a.base}-${a.apelido}-${k}`"
            >
              <td class="alerta-nome">{{ a.apelido }}</td>
              <td>{{ a.hotel || "—" }}</td>
              <td>{{ a.confianca || "—" }}</td>
              <td>
                <strong>{{ a.localizador || "—" }}</strong>
                <span v-if="a.codigo" class="muted"> · {{ a.codigo }}</span>
              </td>
              <td class="muted">{{ a.quando }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="detail-empty detail-empty--ok">
        <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
        Nenhum apelido.
      </div>
    </ListaRecolhivel>
  </div>
</template>

<script>
import ListaRecolhivel from "./ListaRecolhivel.vue";

// Avisos montados pelo agente com a planilha da Azul (e o Phoenix, so leitura). So exibe; nada e alterado.
export default {
  name: "PlanilhaAlertas",
  components: { ListaRecolhivel },
  props: {
    mesmoCpf: { type: Array, default: () => [] },
    foraDaPlanilha: { type: Array, default: () => [] },
    apelidosCriados: { type: Array, default: () => [] },
    verificado: { type: Object, default: () => ({}) },
  },
  data() {
    return { cpfAberto: null };
  },
  methods: {
    chaveCpf(g, k) {
      return `${g.base}-${g.cpf}-${k}`;
    },
    toggleCpf(chave) {
      this.cpfAberto = this.cpfAberto === chave ? null : chave;
    },
    // ISO (UTC) -> "DD/MM/AAAA HH:mm" no horario de Brasilia
    dataHoraBr(iso) {
      const d = new Date(iso);
      if (!iso || Number.isNaN(d.getTime())) return "—";
      const p = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "America/Sao_Paulo",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(d);
      return p.replace(",", "");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.alerta-sub {
  margin: 0 0 12px;
  font-size: 0.82rem;
  color: #6b7580;
}
.alerta-nome {
  font-weight: 600;
}
.alerta-canc {
  min-width: 200px;
}
.alerta-canc__ok {
  display: block;
  font-weight: 600;
  color: #0f7a6e;
}
.alerta-flag {
  display: inline-block;
  margin-top: 4px;
  margin-right: 6px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.72rem;
  background: #fdf0dc;
  color: #b06a12;
}
.alerta-cpf {
  col.col-chevron {
    width: 40px;
  }
  col.col-cpf {
    width: 170px;
  }
  col.col-qtd {
    width: 90px;
  }
  .num {
    text-align: right;
  }
}
.alerta-row {
  cursor: pointer;

  &:hover td,
  &.is-open td {
    background: #f3f6f7;
  }
}
.alerta-chevron {
  padding-right: 0;
  padding-left: 12px;
}
.alerta-chev {
  color: #9aa2ab;
  transition: transform 0.15s ease;

  &.is-open {
    transform: rotate(90deg);
    color: #0f7a6e;
  }
}
.alerta-det td {
  padding: 8px 14px 14px 52px;
  background: #f4f9f8;
}
.alerta-vouchers {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    padding: 2px 0;
  }
}
.alerta-situacao {
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.72rem;
  background: #eef2f6;
  color: #55606c;
}
.mono {
  font-family: monospace;
  white-space: nowrap;
}
</style>
